import xml from 'xml';

export function fromJson(source: object): string {
  const header = `<?xml version="1.0" encoding="UTF-8"?>\n<!DOCTYPE plist PUBLIC "-//Apple Computer//DTD PLIST 1.0//EN" "http://www.apple.com/DTDs/PropertyList-1.0.dtd">\n`;
  const [key, result] = convert(source);

  return (
    header +
    xml(
      {
        plist: [{ _attr: { version: '1.0' } }, { [key]: result }],
      },
      {
        indent: '  ',
      }
    )
  );
}

function convert(source: any): [string, any[]] {
  if (Array.isArray(source)) {
    const result = [];
    for (const element of source) {
      const [indicator, data] = convert(element);
      result.push({ [indicator]: data });
    }

    return ['array', result];
  } else if (typeof source === 'object') {
    const result = [];
    for (const k in source) {
      const [indicator, data] = convert(source[k]);
      const key = k[0].toLocaleUpperCase() + k.slice(1);
      result.push({ key });
      result.push({ [indicator]: data });
    }

    return ['dict', result];
  } else {
    return ['string', source];
  }
}
